/*                                      */

/**
 *
 *
 */
export const VERSION = '5.39.2';
export const PUBLIC_VERSION = '5';
